<template>
  <div class="page">
    <nav-bar title="顺序练习" :fixed="true" :placeholder="true" left-text="返回" left-arrow @click-left="onClickLeft" />

    <div class="summer">
      <div class="avator">
        <img :src="userInfo.picture" v-if="userInfo.picture"/>
        <img src="@assets/images/avatar.jpg" v-else />
      </div>

      <div class="content">
        <div class="name">{{ userInfo.trueName || userInfo.nickname }}</div>
        <div class="sale">{{((info.activeNum || 0)*100/(info.totalNum || 1)).toFixed(1)}}<span class="percent">%</span></div>
        <div class="desc">预测考试通过率</div>

        <div class="data">
          <div class="item">
            <div class="num">{{info.totalNum - info.activeNum || 0}}</div>
            <div class="title">未做题</div>
          </div>
          <div class="item">
            <div class="num">{{info.errorNum || 0}}</div>
            <div class="title">错题</div>
          </div>
          <div class="item">
            <div class="num">{{((info.errorNum || 0)*100/info.activeNum || 1).toFixed(1)}}%</div>
            <div class="title">答错率</div>
          </div>
        </div>
      </div>

      <div class="tools">
        <div class="btn" @click="toPiractice" v-if="info.activeNum>0 && info.activeNum < info.totalNum">继续答题</div>
        <div class="btn" @click="toResult" v-else-if="info.activeNum == info.totalNum">查看答题记录</div>
        <div class="btn" @click="toStart" v-else>开始答题</div>
      </div>

    </div>
  </div>
</template>
<script>
import { NavBar } from "vant";
import { getLibDetail,doStart } from "@api/exam";
import { mapGetters } from "vuex";
import { decrypt } from "@utils/crypto";

export default {
  components: {
    NavBar
  },
  data: function() {
    return {
      id : this.$route.params.id,
      info:{},
      answerSheet: false
    };
  },
  created() {
    this.init();
    console.info(this.userInfo)
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    onClickLeft(val) {
      this.$router.go(-1)
    },
    toPiractice(){
      this.$router.push({path:`/exam/practice/order/start/${this.id}`})
    },
    toStart(){
      doStart(this.id).then(()=>{
        this.$router.push({path:`/exam/practice/order/start/${this.id}`})
      })
    },
    toResult(){
      this.$router.push({path:`/exam/practice/order/result/${this.id}`})
    },
    init() {
      getLibDetail(this.id).then(res => {
        let result = JSON.parse(decrypt(res.result))
        this.info = result || {}
        console.info(this.info)
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  background: url("~@images/practice_bg.png") 0 0 #1db0fc no-repeat;
  min-height: 100vh;

  .summer {
    width: 90%;
    margin: 80px auto;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    min-height: 420px;

    .avator {
      width: 70px;
      height: 70px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border:3px solid #fffffc9e;
      }
    }


    .content {
      position: relative;
      top: 40px;

      .name {
        font-size: 18px;
        color: #666;
        text-align: center;

      }

      .sale{
        margin-top:38px;
        color: #fe5859;
        font-size: 46px;
        font-weight: 700;
        text-align: center;
        .percent{
          font-size: 32px;
        }
      }
      .desc{
        color:#666;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        margin:10px 0;
      }

    }

    .data{
      display: flex;
      padding: 20px 10px;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      margin-top: 45px;

      .item{
        .num{
          font-size: 22px;
          font-weight: 700;
        }
        .title{
          font-size: 14px;
          color: #898989;
          margin: 10px 0;
        }
      }
    }

    .tools{
      margin-top: 35px;

      .btn{
        width: 80%;
        margin:10px auto;
        padding: 10px 0;
        text-align: center;
        background-color: #00aaea;
        color:#fff;
        border-radius: 30px;
      }
    }

  }

}
</style>
